<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-autocomplete
          v-model="formProxy.clientPortal"
          item-value="id"
          item-text="description"
          :items="portals"
          :loading="loadingPortals"
          persistent-hint
          hint="Le client qui sera associé à l'affectation"
          :search-input.sync="portalSearch"
          label="Client"
          :no-data-text="
            portalSearch
              ? 'Aucun portail ne correspond à la recherche'
              : 'Veuillez renseigner un nom de portail'
          "
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" class="pt-0">
        <v-text-field
          v-model="formProxy.prefix"
          label="Préfixe actuel"
          :rules="rules.prefixRules"
          :loading="fetchingPortal"
        ></v-text-field>
      </v-col>
      <v-col cols="12" class="pt-0">
        <v-textarea
          v-model="formProxy.comment"
          label="Commentaire"
          :rules="rules.commentRules"
        ></v-textarea>
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <v-text-field
          type="number"
          label="N° de départ"
          v-model.number="formProxy.beginNumber"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <v-text-field
          type="number"
          label="Nombre de cartes à affecter"
          v-model.number="formProxy.number"
        ></v-text-field>
      </v-col>
      <v-col cols="12" class="pt-0">
        <v-subheader>
          {{ helperText }}
        </v-subheader>
      </v-col>
      <v-col cols="12" md="6" class="pt-0">
        <v-checkbox
          v-model="formProxy.changeSessionsNumber"
          label="Changer le nombre de sessions"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6" class="pt-0">
        <v-text-field
          type="number"
          v-model.number="formProxy.sessionsNumber"
          label="Nombre de sessions"
          :disabled="!formProxy.changeSessionsNumber"
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { defineComponent, ref, watch, computed } from "@vue/composition-api";
import { useClientPortal } from "@/composables/client-portal";

export default defineComponent({
  props: {
    form: Object,
    rules: Object,
  },
  setup(props, { emit }) {
    /* Import des API */
    const { data, criteriaClientPortal, listClientPortals } = useClientPortal();

    /* Variables */
    const portalSearch = ref("");
    const portalTimerId = ref(0);
    const debounceInterval = 500;
    const loadingPortals = ref(false);
    const fetchingPortal = ref(false);

    /* Computed */
    const portals = computed(function () {
      return data.clientPortals.data;
    });
    const formProxy = computed({
      get: function () {
        return props.form;
      },
      set: function (value) {
        emit("update:form", value);
      },
    });
    const helperText = computed(function () {
      if (props.form.prefix && props.form.number && props.form.beginNumber) {
        const end =
          parseInt(props.form.beginNumber) + parseInt(props.form.number) - 1;
        const start = props.form.beginNumber;
        let startString = `${props.form.prefix}`;
        let endString = `${props.form.prefix}`;

        if (start < 10) {
          startString += `100${start}`;
        } else if (start >= 10 && start < 100) {
          startString += `10${start}`;
        } else if (start >= 100 && start < 1000) {
          startString += `1${start}`;
        } else {
          startString += `${start}`;
        }

        if (end < 10) {
          endString += `100${end}`;
        } else if (end >= 10 && end < 100) {
          endString += `10${end}`;
        } else if (end >= 100 && end < 1000) {
          endString += `1${end}`;
        } else {
          endString += `${end}`;
        }

        return `Les cartes ${startString} à ${endString} seront affectées`;
      } else {
        return "-";
      }
    });

    /* Méthodes */
    const fetchPortals = async function () {
      loadingPortals.value = true;
      await listClientPortals(null, portalSearch.value);
      loadingPortals.value = false;
    };

    /* Watchers */
    watch(
      () => portalSearch.value,
      (newValue) => {
        if (newValue) {
          criteriaClientPortal.value.description = newValue;
          clearTimeout(portalTimerId.value);
          portalTimerId.value = setTimeout(() => {
            fetchPortals();
          }, debounceInterval);
        }
      }
    );

    return {
      portals,
      portalSearch,
      formProxy,
      loadingPortals,
      helperText,
      fetchingPortal,
    };
  },
});
</script>
